import React, { useEffect } from 'react';
import { AsideAbout } from '../../_layout/aside-about';

export function Privacy() {
  useEffect(() => {}, []);

  return (
    <main className="sub policy wrapper">
      <AsideAbout />
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>개인정보취급방침</>
        </div>
        <div className="title">
          <h2>개인정보취급방침</h2>
          <p>도서출판 구민사의 홈페이지의 개인정보취급방침입니다.</p>
        </div>
        <section>
          <h3>구민사의 개인정보보호정책</h3>
          <p>
            구민사는 이용자 여러분의 개인정보를 보호하기 위해 개인정보보호정책을 수립하고 이를
            준수합니다.
          </p>
          <p>
            &quot;구민사의 개인정보보호정책&quot;은 수시로 변경될 수 있습니다. 따라서 이용자
            여러분께서는 구민사 사이트를 이용하실 때마다 수시로 이를 확인하시기 바랍니다.
          </p>
        </section>
        <section>
          <h3>개인정보란</h3>
          <p>
            생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명, ID 등의 사항에 의하여 당해
            개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와
            용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.
          </p>
        </section>
        <section>
          <h3>구민사가 수집하는 개인정보는</h3>
          <p>구민사는 서비스 제공에 필요한 최소한의 정보를 수집합니다.</p>
          <h4>필수사항</h4>
          <ul>
            <li>성명</li>
            <li>주소</li>
            <li>전화번호</li>
            <li>희망ID</li>
            <li>비밀번호</li>
            <li>이메일</li>
          </ul>
          <h4>구민사에서 수집하는 개인정보는 다음에 명시한 목적으로만 이용됩니다.</h4>
          <ul>
            <li>회원가입 및 이용ID 발급</li>
            <li>계약의 성립</li>
            <li>개별 회원에 대한 개인 맞춤서비스</li>
            <li>회원의 서비스 이용에 대한 통계를 수집하고, 이를 서비스 정책에 반영</li>
            <li>(서비스 개편 및 확대)</li>
            <li>상품 배송</li>
            <li>요금 및 대금 지급</li>
            <li>새로운 서비스, 신상품이나 이벤트 정보 안내</li>
          </ul>
          <p>
            회원으로 가입할 때 수집된 모든 정보는 해당서비스 제공이나 회원님께 사전에 밝힌 목적
            이외의 다른 어떠한 목적으로도 사용되지 않습니다.
          </p>
        </section>
        <section>
          <h3>제3자에 대한 정보제공</h3>
          <p>
            구민사는 법령에 근거한 다음의 경우를 제외하고는 제3자에게 개인정보를 제공하지 않습니다.
          </p>
          <p>
            금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률, 전기통신기본법,
            전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법령에 특별한 규정이
            있는 경우(법령에 따라 행정관청 또는 수사기관이 요구해 온 경우라도 무조건 개인정보를
            제공하지 않으며, 법령에 규정된 바에 따라 영장 또는 기관장의 직인이 날인된 서면에 의한
            경우에만 제공합니다.)
          </p>
          <p>서비스 제공에 따른 요금정산을 위하여 필요한 경우</p>
          <p>회원가입에 대한 동의 철회, 열람 또는 정정 요구 등</p>
          <p>
            회원님께서는 &quot;회원정보수정&quot;을 통해 언제든지 개인정보에 대한 열람 및 수정을 할
            수 있으며, 수정된 정보는 수정절차가 완료된 시점부터 바로 적용됩니다.
          </p>
          <p>
            회원님께서는 &quot;회원가입해지&quot;를 통해 언제든지 회원가입에 대한 동의를 철회할 수
            있습니다. 회원가입해지를 신청하시면, 해지신청 즉시 제공한 모든 정보를 삭제합니다.
          </p>
        </section>
        <section>
          <h3>수집하는 개인정보의 보유기간 및 이용기간</h3>
          <p>
            다음과 같이 개인정보의 수집 목적 또는 제공받은 목적이 달성되면, 개인정보를 파기합니다.
          </p>
          <p>- 회원가입정보의 경우, 회원가입을 탈퇴하거나 회원에서 제명된 때</p>
          <p>- 대금지급정보의 경우, 대금의 완제일 또는 채권소멸시효기간의 만료된 때</p>
          <p>- 배송정보의 경우, 물품 또는 서비스가 인도되거나 제공된 때</p>
          <p>(단, 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 예외로 합니다.)</p>
        </section>
        <section>
          <h3>쿠키(cookie)의 운영</h3>
          <h4>쿠키(cookie)란?</h4>
          <p>
            웹 사이트 서버가 이용자의 컴퓨터로 전송하는 소량의 정보이며, 여기에는 방문한 웹 사이트의
            정보 및 이용자의 개인정보 등이 담겨있습니다. 이용자는 웹 브라우저의 옵션을 조정함으로써
            모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를
            거부할 수 있는 선택권을 가질 수 있습니다.
          </p>
          <p>구민사의 쿠키 운영</p>
          <p>구민사는 이용자의 편의를 위하여 쿠키를 운영합니다.</p>
          <p>
            웹클래스가 쿠키를 통해 수집하는 정보는 구민사 회원 ID에 한하며, 그 외의 다른 정보는
            수집하지 않습니다. 구민사가 쿠키(cookie)를 통해 수집한 회원 ID는 아래의 목적을 위해
            사용됩니다.
          </p>
          <p>1) 구민사 각종 정보 서비스 이용 시</p>
          <p>2) 개인 맞춤 서비스 제공</p>
          <p>3) 유료서비스 이용 시 이용기간 안내</p>
          <p>4) 게시판 글 등록</p>
          <p>쿠키는 브라우저의 종료 시나 로그아웃 시 만료됩니다.</p>
        </section>
        <section>
          <h3>개인정보 관리책임자</h3>
          <p>조규백 (02)701-7421, kuhminsa@kuhminsa.co.kr</p>
          <p>
            한편, 회원님께서는 구민사와 개인정보에 관한 분쟁이 있는 경우 신속하고 효과적인
            분쟁해결을 위하여 한국정보보호센터 내의 개인정보분쟁조정위원회에 그 처리를 의뢰할 수
            있습니다.
          </p>
          <p>- 개인정보침해신고센터 전화: 서울 1336, 지방(02)1336</p>
          <p>- 개인정보침해신고센터 URL: www.1336.or.kr</p>
          <p>개인정보보호정책 버전번호: v1.0</p>
          <p>개인정보보호정책 시행일자: 2012-08-01</p>
          <p>개인정보보호정책 게시일자: 2012-08-01</p>
        </section>
        <section>
          <h3>이메일주소 무단수집거부</h3>
          <h4>정보통신망 이용촉진 및 정보보호등에 관한 법률</h4>
          <p>
            구민사 사이트내에 게시되어 있는 이메일 주소가 &#39;이메일 주소 수집프로그램&#39;이나
            그밖의 기술적 장치를 사용하여 무단으로 수집되는 것을 거부하며, 이를 위반하였을 경우
            정보통신법망에 의해 형사처벌될 수 있음을 유념하시기 바랍니다.
          </p>
        </section>
        <section>
          <h4>제50조의 2(전자우편주소의 무단 수집행의 등 금지)</h4>
          <ul>
            <li>
              ① 누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로
              전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를
              수집하여서는 아니된다.
            </li>
            <li>
              ② 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니된다.
            </li>
            <li>
              ③ 누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된 전자우편주소임을
              알고 이를 정보전송에 이용하여서는 아니된다.
            </li>
          </ul>
        </section>
        <section>
          <h4>제65조의 2(벌칙) 다음 각호의 1에 해당하는 자는 1천만원 이하의 벌금에 처한다.</h4>
          <p>
            ③ 제 50조 2의 규정을 위반하여 전자우편주소를 수집, 판매, 유통 또는 정보전송에 이용한 자
          </p>
        </section>
      </div>
    </main>
  );
}
